import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/admin/roles/search', { params: request })
  },
  find: function (id) {
    return axios.get(`/api/admin/roles/find?id=${id}`);
  },
  create: function (data) {
    return axios.post(`/api/admin/roles`, data);
  },
  update: function(data) {
    return axios.put(`/api/admin/roles/${data.id}`, data);
  },
  delete: function (id) {
    return axios.delete(`/api/admin/roles/${id}`);
  },
  loadPermissions: function() {
    return axios.get('/api/admin/permissions/search', { params: {pageNumber: 1, pageSize: 500} });
  },
  addRolesToOrganizations(data) {
    return axios.post(`/api/admin/roles/organizations/add`, data);
  },
  removeRolesFromOrganizations(data) {
    return axios.post(`/api/admin/roles/organizations/remove`, data);
  },
  updateOrganizationRoles(data) {
    return axios.post(`/api/admin/roles/organizations/update`, data);
  }
}